<template>
  <div class="content">    
	<app-header></app-header> 
	<div class = "toCertification">
		<div class="container">
			<h2 class="title">立即完成招聘者身份审核</h2>
			<h2>不错过任何一个简历</h2>
			<p class="dif">完成身份审核，即可获得以下权限</p>
			<p><span class="icon iconfont">&#xe645;</span>发布职位进行招聘</p>
			<p><span class="icon iconfont">&#xe645;</span>管理职位与候选人</p>
			<p v-if="verified ==5"><router-link to="/identityReview">{{contentText}}</router-link></p>
			<img src="../../assets/imgs/companyRegBg.png" alt="科研人才网-事业单位硕士博士科研人才招聘">
		</div>
	</div>
	<app-footer></app-footer>
  </div>
</template>




<script> 
import AppFooter from '../../components/common/footer.vue'
import AppHeader from '../../components/common/header1.vue'
export default {
  name: 'unCertification',
  components: {AppFooter,AppHeader },
    data () {
    	return {
	        morelinkFlag:false,
    			morelinkText:"展开",
				verified:5,
				contentText:'去完成招聘者身份审核',
    	}
	  },
    created:function () {
	    this.$emit('header', true);
	    this.$emit('footer', true);
	},
	methods:{
		getLogin:function(){
			let _self = this;
			
		},
		verifiedCompany:function(){	//查询审核状态
			let _self = this;
			let userId = localStorage.getItem('_id');

		  	// let urls = 'https://www.uncle119.com/api/verified/hunter/'+userId;
			// _self.$http.get(urls).then(
			// 			function(response) {
		    //     if(response.body.code == 200){
		    //     	let verified = response.body.data.verified;
			// 		console.log(_self.verified);
			// 		if(verified === 0){
			// 			_self.$layer.msg("您填写的信息有误，请重新填写！");
			// 			_self.contentText = "重新填写招聘者审核"
			// 		}else if(verified === 1){
			// 			_self.$router.push({ path:'/companyCertification'})
			// 		}else if(verified === 2){
			// 			_self.verified = verified;
			// 			_self.$layer.msg("正在审核中，请耐心等待");
			// 		}
		    //     }else{
		    //     	console.log(response.body.msg);
		    //     }
			// 	},
			// 	function(response) {
			// 		_self.$layer.msg(response.body.msg);	            
			// 	}
			// )
		},
	},
	mounted:function(){
		this.verifiedCompany();//查询审核状态
		this.getLogin();
	}
	
}
</script>

<style  lang = "less"  scoped="scoped">
//滚动条
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #f1f1f1;
}

//滚动条轨道 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #f1f1f1;
    -moz-box-shadow: inset 0 0 6px #f1f1f1;
    box-shadow: inset 0 0 6px #f1f1f1;
    background-color: #f1f1f1;
}

//滑块
::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px #c1c1c1;
    -moz-box-shadow: inset 0 0 6px #c1c1c1;
    box-shadow: inset 0 0 6px #c1c1c1;
    border-radius: 3px;
    background-color: #c1c1c1;
}
.content{
	width: 100%;
	height: 760px;
	position: relative;
	background-color: #f8f9fc;	
	.toCertification{
		width: 100%;
		height: 630px;
		background-color: #F4F8FF;
		/* background: url(../../assets/images/certificationbg.png) no-repeat center center; */
		.container{
			width: 1200px;
			padding-top: 140px;
			margin: 0 auto;
			position: relative;
			img{
				position: absolute;
				top: 120px;
				right: 0;
			}
			h2{
				font-size: 40px;
				color: #1787FB;
			}
			p{
				height: 42px;
				line-height: 42px;
				color: #1787FB;
				.iconfont{
					color: #1787FB;
				}
				a{
					display: inline-block;
					width: 250px;
					height: 52px;
					line-height: 52px;
					text-align: center;
					color: white;
					background-color: #1787FB;
					margin-top: 10px;
				}
				a:hover{
					background-color: #1787FB;
				}
			}
			.dif{
				margin-top: 20px;
				color: #1787FB;
			}
		}
		
	}
}

</style>



// WEBPACK FOOTER //
// src/views/companyRegister/unCertification.vue